<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 公章材质管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="公章材质:" label-width="75px">
                        <el-input v-model="query.material" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                >批量删除</el-button>
               
                 <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
                 <el-button
                    type="primary"
                    icon="el-icon-s-goods"
                    @click="delAllSelection"
                >回收站</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="materials" label="公章材质"  align="center"></el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                        <el-button size="mini"
                            :type="scope.row.state==='成功'?'warning':(scope.row.state==='失败'?'success':'')"
                             :icon="scope.row.state==='成功'?'el-icon-error':(scope.row.state==='失败'?'el-icon-success':'')"
                             @click="updateState(scope.$index,scope.row)"
                        >
                          <span v-if="scope.row.state==='成功'">禁用</span>
                          <span v-else>启用</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加弹出框 -->
        <el-dialog title="添加公章材质" :visible.sync="addVisiable" width="500px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="100px" >
               <el-form-item prop="materials" label="公章材质">
                     <el-input v-model="addForm.materials"></el-input>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑公章材质" :visible.sync="editVisible" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
                 <el-form-item label="公章材质" prop="materials">
                    <el-input v-model="editForm.materials"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {

            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                material: '',
                pageIndex: 1,
                pageSize: 6
            },
            pageTotal: 7,
            //添加数据
            addVisiable:false,
            addForm:{
               shape:'',
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                materials: [
                    { required: true, message: '请输入公章材质', trigger: 'blur' },
                ]
               
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    methods: {
        addData(){
            let formdata = new FormData()
            formdata.append('materials',this.addForm.materials)
            formdata.append('company_id',this.companyid)
            let url  = 'admin/seal/addMeta'
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    post(url,formdata).then(res=>{
                        if(res.data.msg =="添加成功"){
                            this.$message.success("添加成功")
                            this.getData()
                            this.$refs['addForm'].resetFields();
                            this.addVisiable = false 
                        }
                        else{
                            this.$messaga.error("添加失败")
                        }          
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        updateStatus(index,row){
            let formdata = new FormData()
            let url = 'admin/admin_user/disables'
            formdata.append('id',row.id)
            if(row.disable==1){
                url = 'admin/admin_user/starts'
            }
            post(url,formdata).then(res=>{
                if(res.data.msg =="禁用失败"){
                    this.$message.error("禁用失败")
                } 
                else if(res.data.msg =="禁用成功"){
                    this.$message.success("禁用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用成功"){
                    this.$message.success("启用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用失败"){
                    this.$message.error("启用失败")
                    this.getData()
                }      
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
            this.query.material= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('materials',this.query.material)
            post('admin/seal/seaMeta',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.data.length
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('materials',this.query.material)
            post('admin/seal/seaMeta',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/seal/deleMeta',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            if(this.pageTotal/this.query.pageSize<this.query.pageIndex)
                                this.query.pageIndex = this.query.pageIndex -1
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/seal/deleMeta',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('materials',this.editForm.materials)
                    post('admin/seal/updaMeta',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
